// export const API_ROOT = process.env.REACT_APP_API_ROOT;
// export const ROOT_PATH = process.env.REACT_APP_ROOT_PATH;
export const API_ROOT = window._env_ != null ? window._env_.APP_API_ROOT : "";
export const ROOT_PATH = window._env_ != null ? window._env_.APP_ROOT_PATH : "";
export const RAZORPAY_KEY = window._env_ != null ? window._env_.RAZORPAY_KEY : "";
export const WHITELISTED_IP_ADDRESS = window._env_ != null ? window._env_.WHITELISTED_IP : "*";
export const BLACKLISTED_IP_MESSAGE = window._env_ != null ? window._env_.BLACKLISTED_MESSAGE : "";
export const SESSION_TOKEN = "SESSION_TOKEN";
export const DISABLE_SEND_SMS_LINK = window._env_ != null ? window._env_.DISABLE_SEND_SMS_LINK : false;
export const FORGOT_PASSWORD_TIMER = window._env_ != null ? window._env_.FORGOT_PASSWORD_TIMER : 60;
export const PROJECT_LOGO = window._env_ != null ? window._env_.mainLogo : "";
export const NEW_ATTENDANCE_SHEET_HEADER = window._env_ != null ? window._env_.NEW_ATTENDANCE_SHEET_HEADER : ['100', '200', '300', '500', '1000'];
export const ASSIGN_CENTER_PAGINATION = window._env_ != null ? window._env_.ASSIGN_CENTER_PAGINATION : ['100', '200', '300', '500', '1000'];
export const DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK = window._env_ != null ? window._env_.DISABLE_SEND_SMS_EMAIL_INTERVIEW_CALL_LETTER_LINK : false;
export const DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK = window._env_ != null ? window._env_.DISABLE_SEND_SMS_EMAIL_HALL_TICKET_LINK : false;
export const DOWNLOAD_INTERVIEW_CALL_LETTER = window._env_ != null ? window._env_.DOWNLOAD_INTERVIEW_CALL_LETTER : false;
export const SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE = window._env_ != null ? window._env_.SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE : false;
export const REGISTRATION_DISABLE = window._env_ != null ? window._env_.REGISTRATION_DISABLE : false;
export const DOWNLOAD_APPOINTMENT_LETTER = window._env_ != null ? window._env_.DOWNLOAD_APPOINTMENT_LETTER : false;
export const token = window._env_ != null ? window._env_.token : false;
export const otpResendTimeout = window._env_ != null ? window._env_.otpResendTimeout : false;
export const OTP_GENERATION_LIMIT = window._env_ != null ? window._env_.OTP_GENERATION_LIMIT : false;
export const OTP_LIMIT_ERROR_MSG = window._env_ != null ? window._env_.OTP_LIMIT_ERROR_MSG : false;
export const CANDIDATE_REMARK = window._env_ != null ? window._env_.CANDIDATE_REMARK : [
    "Fingerprint matched successfully",
    "Fingerprint did not match",
    "Scanner unable to read fingerprint – retry limit reached – verified using documents",
    "Candidate has finger/thumb injury – verified using documents",
    "Candidate has mehendi/ink/stain – verified using documents",
    "Candidate refused fingerprint scan – verified using documents",
    "Fingerprint scanner hardware issue – verified using documents",
    "Candidate has worn-out fingerprints – verified using documents",
    "Other (specify manually)"
];
export const Is_Aadharverification_PostExam = window._env_ != null ? window._env_.Is_Aadharverification_PostExam : false;
export const GENERATE_AADHAAR_OTP = window._env_ != null ? window._env_.GENERATE_AADHAAR_OTP : false;
export const SUBMIT_AADHAAR_OTP = window._env_ != null ? window._env_.SUBMIT_AADHAAR_OTP : false;


// MaheshR
//Login Page
export const LOGIN = 'registration/StudentLogin';
export const APP_USER_ID = 'APP_USER_ID';
export const GET_CHANGE_PASSWORD = 'registration/UpdateStudentPassword';
export const GET_PORTAL_CONFIG = "PortalConfiguration/GetPortalConfiguration";
export const GET_PORTAL_CONFIG_BY_KEY = "PortalConfiguration/GetPortalConfigurationByKey";

//AdminService
export const ADMIN_LOGIN = 'registration/AdminLogin';
export const ADMIN_DASHBOARD = 'Registration/GetAdminDashboardData';
export const VALIDATE_LICENCE_KEY = 'Registration/ValidateLicenceKey';
export const UPDATE_PORTAL_CONFIG = 'PortalConfiguration/AddOrUpdatePortalConfiguration';
export const GET_ALL_POSTS = 'Post/GetAllPost';
export const GET_POSTS = 'Post/GetPost';
export const GET_POST_DATA = 'Post/GetPostData';
export const ADD_UPDATE_POSTS = 'Post/AddOrUpdatePost';
export const DELETE_POST = 'Post/DeletePost';
export const GET_ALL_CATEGORY_ADMIN = 'Category/GetAllCategory';
export const GET_ALL_CATEGORY = 'Registration/GetAllCategory';
export const ADD_UPDATE_CATEGORY = 'Category/AddOrUpdate';
export const DELETE_CATEGORY = 'Category/DeleteCategory';
export const GET_ALL_UNIVERSITIES = 'Registration/GetAllUniversity';
export const ADD_UPDATE_UNIVERSITY = 'UniversityDetail/AddOrUpdateUniversity';
export const DELETE_UNIVERSITY = 'UniversityDetail/DeleteUniversity';
export const GET_ALL_DEGAREES = 'QualificationMaster/GetAllQualificationDegrees';
export const ADD_UPDATE_QUALIFICATION = 'QualificationMaster/AddOrUpdateQualification';
export const DELETE_QUALIFICATION = 'QualificationMaster/DeleteQualification';
export const GET_ALL_CENTER = 'Center/GetAllCenter';
export const ADD_UPDATE_CENTER = 'Center/AddOrUpdateCenter';
export const DELETE_CENTER = 'Center/DeleteCenter';
export const GET_ALL_CLASSROOMS = 'ClassRoom/GetAllClassRoom';
export const ADD_UPDATE_CLASSROOMS = 'ClassRoom/AddOrUpdateClassRoom';
export const DELETE_CLASSROOM = 'ClassRoom/DeleteClassRoom';
export const GET_ALL_SPECIFICATIONS = 'QualificationMaster/GetAllQualificationSpecilization';
export const ADD_UPDATE_SPECIFICATION = 'QualificationMaster/AddOrUpdateQualification';
export const DELETE_SPECIFICATION = 'QualificationMaster/DeleteQualification';
export const GET_CHALAN_BANK_DETAILS = 'ChallanBankDetail/GetChallanBankDetailData';
export const ADD_CHALAN_BANK_DETAILS = 'ChallanBankDetail/AddOrUpdateChallanBankDetail';
export const DELETE_CHALAN_BANK_DETAILS = 'ChallanBankDetail/DeleteChallanBankDetail';
export const GET_ALL_STUDENTS = 'Registration/GetAllStudentData';
export const GET_ALL_RAZORPAY_TRANSACTIONS = 'RazorPayTransaction/GetAllRazorPayTransactions';
export const REFUND_TRANSACTION = 'RazorPayTransaction/RefundTransaction';
export const GET_ALL_STUDENTS_FOR_REVIEW = 'Registration/GetStudentDataForReview';
export const UPDATE_STUDENT_DATA = 'Registration/UpdateStudentApprovedRejectedData';
export const READ_EXCEL = 'ReadExcel/ReadFile';
export const UPDATE_STUDENT_STATUS = 'Registration/UpdateStudentApprovedOrRejectedStatus';
export const EXPORT_ALL_STUDENTS = 'Registration/ExportAllStudentData';
export const GET_ALL_STUDENTS_ATTENDANCE = 'Registration/GetAllStudentsAttendanceSheet';
// Recruitment Candidate-List Publication Modernization phase.
export const GET_ELIGIBLE_CANDIDATES = 'Registration/GetEligibleCandidates';
export const EXPORT_ATTENDANCE_EXCEL = 'ExportedExcel/StudentAttendance';
export const EXPORT_RESULT_EXCEL = 'ExportedExcel/AllStudentDataResult';
export const UPDATE_STUDENT_BATCH = 'Registration/UpdateStudentCenterAndBatch';
export const REMOVE_STUDENT_FROM_BATCH = 'Registration/RemoveStudentFromCenterAndBatch';
export const GET_ALL_STUDENTS_BY_CENTER = 'Registration/GetAllStudentDataByCenterAndBatch';
export const GET_ALL_STATES = 'Registration/GetAllStates';
export const GET_ALL_DISTRICT = 'Registration/GetAllDistricts';
export const GET_ALL_TALUKAS = 'Registration/GetAllTalukas';
export const UPDATE_STUDENT_ROLL_NUMBER = 'StudentRollNumber/AddUpdateStudentRolleNumber';
export const GET_ALL_STUDENTS_ROLL_NUMBER = 'StudentRollNumber/GetAllStudentRollNumberData';
export const REGENERATE_STUDENTS_ROLL_NUMBER = 'StudentRollNumber/RegenerateStudentRollNumber';
export const ADD_UPDATE_STUDENT_NOTIFICATION = 'StudentNotification/AddOrUpdateStudentNotification';
export const EXPORT_ALL_STUDENTS_BATCHES = "StudentRollNumber/ExportAllStudentRollNumberData";
export const EXPORT_ALL_STUDENTS_DATA = "Registration/ExportAllStudentsHasRollNumberData";
export const EXPORT_ALL_STUDENTS_BATCHES_EXCEL = 'ExportedExcel/AllStudentRollNumberDataResult';
export const EXPORT_ALL_STUDENTS_DATA_EXCEL = 'ExportedExcel/AllStudentHasRollNumberDataResult';
export const IMPORT_STUDENT_RESULT = "StudentResult/ImportStudentResult";
export const IMPORT_STUDENT_INTERVIEW_RESULT = "StudentResult/ImportStudentInterviewMarks";

// Primary Result Automation & Interview Shortlisting phase.
export const PREVIEW_INTERVIEW_SHORTLIST = "StudentResult/PreviewInterviewShortlist";
export const CONFIRM_INTERVIEW_SHORTLIST = "StudentResult/ConfirmInterviewShortlist";

// Interview Marks Workflow & Final Result Foundation phase.
export const IMPORT_FINAL_RESULT = "StudentResult/ImportFinalResult";
export const PREVIEW_FINAL_RESULT = "StudentResult/PreviewFinalResult";
export const PUBLISH_FINAL_RESULT = "StudentResult/PublishFinalResult";
export const GET_PUBLISHED_SELECTED_WAITING_ROLL_NUMBERS = "StudentResult/GetPublishedSelectedWaitingRollNumbers";
export const EXPORT_INTERVIEW_BLIND_DATA = "StudentResult/ExportInterviewBlindData";
export const GET_STUDENT_RESULT_BY_APPLICATION_ID = "StudentResult/GetStudentResultByApplicationId";
export const GET_ALL_STUDENT_ANSWER_PAPER_LIST = "StudentAnswerPaper/GetAllStudentAnswerPaperList";
export const Add_Or_Update_Student_Answer_Paper = "StudentAnswerPaper/AddOrUpdateStudentAnswerPaper";
export const DELETE_STUDENT_ANSWER_PAPER = "StudentAnswerPaper/DeleteStudentAnswerPaper";
export const GET_STUDENT_ANSWER_PAPER_PDF_NAME = "StudentAnswerPaper/GetStudentAnswerPaperPDFName";

export const SEND_BULK_SMS_FOR_HALL_TICKET_DOWNLOAD = "Registration/SendBulkSMSForHallTicketDownload";
export const GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_SMS = "Registration/GetStudentListForSendRetryHallTicketMessage";
export const SEND_RETRY_SMS_FOR_HALL_TICKET_DOWNLOAD = "Registration/SendRetryMSForHallTicketDownload"

export const SEND_BULK_EMAIL_FOR_HALL_TICKET_DOWNLOAD = "Registration/SendBulkEmailForHallTicketDownload";
export const GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_EMAIL = "Registration/GetStudentListForSendRetryHallTicketEmail";
export const SEND_RETRY_EMAIL_FOR_HALL_TICKET_DOWNLOAD = "Registration/SendRetryEMAILForHallTicketDownload";

export const SEND_BULK_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD = "Registration/SendBulkSMSForInterviewCallLetterDownload";
export const GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_SMS = "Registration/GetStudentListForSendRetryInterviewCallleterMessage";
export const SEND_RETRY_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD = "Registration/SendRetrySMSForInterviewCallleterDownload"

export const SEND_BULK_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD = "Registration/SendBulkEmailForInterviewCallLetterDownload";
export const GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_EMAIL = "Registration/GetStudentListForSendRetryInterviewCallleterEmail";
export const SEND_RETRY_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD = "Registration/SendRetryEMAILForInterviewCallleterDownload"

export const SEND_BULK_SMS_FOR_VIEW_RESULT_SMS = "Registration/SendBulkSMSForViewResult";
export const SEND_BULK_EMAIL_FOR_VIEW_RESULT = "Registration/SendBulkViewResultEmail";
export const GENERATE_LICENSE_KEY = "Registration/GenerateLicenseKey";

export const GET_PORTAL_CONFIG_WITHOUT_IMAGE = "PortalConfiguration/GetPortalConfigurationWithoutImage";


//StudentService
export const GET_STUDENT_DATA = 'Registration/GetStudentData';
export const UPDATE_STUDENT_PERSONAL_DATA = 'Registration/UpdateStudentPersonalData';
export const GET_STUDENT_RESERVATION_DATA = 'Registration/GetStudentReservationData';
export const GET_STUDENT_QUALIFICATION_DATA = 'Registration/GetStudentQualificationData';
export const UPDATE_STUDENT_RESERVATION_DATA = 'Registration/UpdateStudentReservationData';
export const UPDATE_STUDENT_QUALIFICATION_DATA_OLD = 'Registration/UpdateStudentQualificationData';
export const UPDATE_STUDENT_QUALIFICATION_DATA = 'Registration/UpdateStudentQualificationDataV1';
export const GET_STUDENT_IMAGE_DATA = 'Registration/GetStudentImagesData';
export const UPLOAD_PROFILE_IMAGE = 'UploadImages/UploadImage';
export const UPLOAD_SIGNATURE_IMAGE = 'UploadImages/UploadImage';
export const UPLOAD_AADHAAR_IMAGE = 'UploadImages/UploadPdfImage';
export const UPDATE_STUDENT_IMAGE_DATA = 'Registration/UpdateStudentImageData';
export const GET_ALL_QUALIFICATION = 'Registration/GetAllQualification';
export const GET_STUDENT_RECEPT_DATA = 'Registration/GetStudentReceiptData';
export const GET_STUDENT_PROCESS_STATUS = 'Registration/GetStudentProcessStatus';
export const SUBMIT_STUDENT_FORM = 'Registration/SubmitData';
export const DOWNLOAD_STUDENT_EXAM_CARD = 'Registration/UpdateStudentExamCardDownloadFlag';
export const GET_ALL_NOTIFICATIONS = 'StudentNotification/GetAllNotifications';
export const UPDATE_STUDENT_NOTIFICATIONS = 'StudentNotification/UpdateStudentNotifications';
export const REGISTER = 'registration/StudentRegistration';
export const UPDATESTUDENTDATEOFBIRTH = "Registration/UpdateStudentDateOfBirth";

export const GET_STUDENT_DATA_FOR_ADMIN = "Registration/GetStudentDataForAdmin";
export const GET_STUDENT_RECEIPT_DATA_FOR_ADMIN = "Registration/GetStudentReceiptDataForAdmin";
export const GET_TOTAL_STUDENT_REGISTER_DATA = 'Registration/GetTotalStudentRegisterData';

export const GET_STUDENT_DATA_FOR_ATTENDANCE = "Registration/GetStudentDataForAttendance"
export const IMPORT_STUDENT_ATTENDANCE_DATA = "AttendanceData/ImportStudentAttendanceData";
export const GET_ALL_CENTER_LIST = "AttendanceData/GetAllCenterList";
export const GET_ALL_BATCH_CENTER_BY_NAME = 'AttendanceData/GetAllBatchNameByCenterName';
export const GET_ALL_ATTENDANCE_DATA = 'AttendanceData/GetAllAttendanceData';
export const DELETE_STUDENT_ATTENDANCE_DATA = "AttendanceData/DeleteStudentAttendanceData";
export const GET_DISTINCT_POST_BY_CENTER_AND_BATCH = "AttendanceData/GetDistinctPostByCenterAndBatch";

export const GET_STUDENT_AKSHEP_DATA_FOR_STUDENT = 'StudentAakshepData/GetStudentAakshepDataForStudent';

export const GET_ALL_STUDENT_AKSHEP_DATA = 'StudentAakshepData/GetAllStudentAakshepData';
export const DELETE_STUDENT_AKSHEP_DATA = 'StudentAakshepData/DeleteStudentAakshepData';
export const ADD_UPDATE_STUDENT_AKSHEP_DATA = 'StudentAakshepData/AddOrUpdateStudentAakshepData';
export const GET_STUDENT_AKSHEP_DATA = 'StudentAakshepData/GetStudentAakshepData';

export const IMPORT_CENTER_BATCH_DATA = "CenterBatchData/ImportCenterBatchData";
export const GET_ALL_CENTER_BATCH_LIST = "CenterBatchData/GetAllCenterBatchList";
export const DELETE_CENTER_BATCH_DATA = "CenterBatchData/DeleteCenterBatchData";
export const IMPORT_CENTER_BATCH_LAB_COUNT_DATA = "CenterBatchData/ImportCenterBatchLabCountData";
export const DELETE_CENTER_BATCH_LAB_COUNT_DATA = "CenterBatchData/DeleteCenterBatchLabCountData";
export const GET_ALL_CENTER_BATCH_DATA_BY_CENTER = "CenterBatchData/GetAllCenterBatchDataByCenter";
export const GET_DISTINCT_EXAM_DATE_BY_CENTER_NAME = "CenterBatchData/GetDistinctExamDateByCenterName";
export const GET_ALL_CENTER_BATCH_LAB_COUNT_DATA_BY_CENTER_AND_DATE = "CenterBatchData/GetAllCenterBatchLabCountDataByCenterAndDate";
export const GET_DISTINCT_CENTER_FROM_BATCH_LAB_COUNT = "CenterBatchData/GetDistinctCenterFromBatchLabCount";
export const EXPORT_CENTER_WISE_ATTENDANCE_DATA = "CenterBatchData/ExportCenterWiseAttendanceData";

export const IMPORT_STUDENT_INTERVIEW_TIME_DATA = "StudentResult/ImportStudentInterviewTimeData";
export const GET_DISTINCT_POST_FROM_STUDENT_INTERVIEW_TIME_DATA = "StudentResult/GetDistinctPostFromStudentInterviewTimeData";
export const GET_ALL_STUDENT_INTERVIEW_TIME_DATA_BY_POST = "StudentResult/GetAllStudentInterviewTimeDataByPost";
export const DELETE_STUDENT_INTERVIEW_TIME_DATA = "StudentResult/DeleteStudentInterviewTimeData";

export const GET_ALL_DISABLE_CATEGORIES = 'Category/GetAllDisableCategories';
export const UPLOAD_SCRIBE_IMAGE = 'UploadImages/UploadScribeImage';

//InterView Call Letter
export const GET_STUDENT_INTERVIEW_TIME_DATE_BY_APPLICATION_ID = "StudentResult/GetStudentInterviewTimeDateByApplicationID";

export const IMPORT_STUDENT_APPOINTMENT_DATA = "StudentAppointment/ImportStudentAppointmentData";
export const GET_DISTINCT_POST_FROM_STUDENT_APPOINTMENT_DATA = "StudentAppointment/GetDistinctPostFromStudentAppointmentData";
export const GET_ALL_STUDENT_APPOINTMENT_DATA_BY_POST = "StudentAppointment/GetAllStudentAppointmentDataByPost";
export const DELETE_STUDENT_APPOINTMENT_DATA = "StudentAppointment/DeleteStudentAppointmentData";

//Appointment Letter
export const GET_STUDENT_APPOINTMENT_DATA_BY_ROLE_NUMBER = "StudentAppointment/GetStudentAppointmentDataByRoleNumber";

//NavBar
export const LOGOUT = 'logout/';

//#region session-keys
export const USER_NAME = 'UserName';
export const USER_ROLE = 'UserRole';
export const PROFILE_URL = 'ProfileUrl';
export const USER_COMPANY = 'Company';
export const Last_LOGIN_DATETIME = "Last_LoggedIn";

//#region apis
export const FORGOT_PASSWORD = 'forget_password/';
export const RESET_PASSWORD = 'reset_password/';
export const SET_PASSWORD = 'set_password/';
export const FORGET_PASSWORD_SEND_OTP = 'Registration/ForgetPasswordSendOTP'

export const FORGOT_STUDENT_PASSWORD = "Registration/ForgotStudentPassword";

// Sprint 2.2 (Privacy & Consent Foundation)
export const SUBMIT_CONSENT = "Consent/SubmitConsent";
export const GET_CURRENT_CONSENT_VERSION = "Consent/GetCurrentConsentVersion";

// Sprint 2.2 (Governance & Approval Foundation)
export const GOVERNANCE_SUBMIT_FOR_APPROVAL = "Governance/SubmitForApproval";
export const GOVERNANCE_GET_PENDING_REQUESTS = "Governance/GetPendingRequests";
export const GOVERNANCE_APPROVE = "Governance/Approve";
export const GOVERNANCE_REJECT = "Governance/Reject";
export const AUDIT_LOG_SEARCH = "AuditLog/Search";

// Sprint 2.3 (Enterprise Configuration Framework + Feature Flag Framework)
export const ENTERPRISE_CONFIG_GET_ALL = "EnterpriseConfig/GetAll";
export const ENTERPRISE_CONFIG_GET_BY_CATEGORY = "EnterpriseConfig/GetByCategory";
export const ENTERPRISE_CONFIG_UPDATE = "EnterpriseConfig/Update";
export const ENTERPRISE_CONFIG_IS_FEATURE_ENABLED = "EnterpriseConfig/IsFeatureEnabled";
export const ENTERPRISE_CONFIG_GET_BRANDING = "EnterpriseConfig/GetBrandingConfig";
// Stage 3.9 (Enterprise Candidate Experience Final UI Polish & UX Optimization)
export const ENTERPRISE_CONFIG_GET_LANGUAGE = "EnterpriseConfig/GetLanguageConfig";

// Phase C.1 (Enterprise Publication Foundation) — admin-driven candidate-facing PDF publications,
// replacing the developer-dependent model of hand-placing files in IIS folders and hard-binding paths.
export const PUBLICATION_GET_ACTIVE = "Publication/GetActivePublications";
export const PUBLICATION_GET_DOCUMENT_ACCESS_URL = "Publication/GetDocumentAccessUrl";
export const PUBLICATION_GET_ALL = "Publication/GetAll";
export const PUBLICATION_GET_BY_ID = "Publication/GetById";
export const PUBLICATION_CREATE = "Publication/Create";
export const PUBLICATION_UPDATE = "Publication/Update";
export const PUBLICATION_PUBLISH = "Publication/Publish";
export const PUBLICATION_UNPUBLISH = "Publication/Unpublish";
export const PUBLICATION_ARCHIVE = "Publication/Archive";
export const PUBLICATION_SUPERSEDE = "Publication/Supersede";

// Phase C.9 (Answer Key & Lightweight Online Objection Workflow) — a Candidate Login artifact (never
// publicly published, unlike Publication above); batch-scoped, authenticated access only.
export const ANSWER_KEY_GET_FOR_CANDIDATE = "AnswerKey/GetForCandidate";
export const ANSWER_KEY_GET_ALL = "AnswerKey/GetAll";
export const ANSWER_KEY_GET_BY_ID = "AnswerKey/GetById";
export const ANSWER_KEY_CREATE = "AnswerKey/Create";
export const ANSWER_KEY_PUBLISH = "AnswerKey/Publish";
export const ANSWER_KEY_UNPUBLISH = "AnswerKey/Unpublish";
export const ANSWER_KEY_ARCHIVE = "AnswerKey/Archive";
export const ANSWER_KEY_SUPERSEDE = "AnswerKey/Supersede";

export const ANSWER_KEY_OBJECTION_SUBMIT = "AnswerKeyObjection/Submit";
export const ANSWER_KEY_OBJECTION_GET_MINE = "AnswerKeyObjection/GetMyObjections";
export const ANSWER_KEY_OBJECTION_GET_MY_PROOF_URL = "AnswerKeyObjection/GetMyProofAccessUrl";
export const ANSWER_KEY_OBJECTION_SEARCH = "AnswerKeyObjection/Search";
export const ANSWER_KEY_OBJECTION_GET_BY_ID = "AnswerKeyObjection/GetById";
export const ANSWER_KEY_OBJECTION_GET_PROOF_URL = "AnswerKeyObjection/GetProofAccessUrl";
export const ANSWER_KEY_OBJECTION_UPDATE_STATUS = "AnswerKeyObjection/UpdateStatus";

// Phase B (Interview Scheduling) — a Candidate Login artifact (never publicly published), independent
// of the legacy StudentInterviewTimeData mechanism.
export const INTERVIEW_SCHEDULE_VALIDATE_IMPORT = "InterviewSchedule/ValidateImport";
export const INTERVIEW_SCHEDULE_CONFIRM_IMPORT = "InterviewSchedule/ConfirmImport";
export const INTERVIEW_SCHEDULE_SEARCH = "InterviewSchedule/Search";
export const INTERVIEW_SCHEDULE_GET_BY_ID = "InterviewSchedule/GetById";
export const INTERVIEW_SCHEDULE_RELEASE = "InterviewSchedule/Release";
export const INTERVIEW_SCHEDULE_UNRELEASE = "InterviewSchedule/Unrelease";
export const INTERVIEW_SCHEDULE_ARCHIVE = "InterviewSchedule/Archive";
export const INTERVIEW_SCHEDULE_UPDATE = "InterviewSchedule/Update";
export const INTERVIEW_SCHEDULE_GET_FOR_CANDIDATE = "InterviewSchedule/GetForCandidate";

// Phase C (Interview Call Letter).
export const INTERVIEW_SCHEDULE_VALIDATE_CALL_LETTER_RELEASE = "InterviewSchedule/ValidateCallLetterRelease";
export const INTERVIEW_SCHEDULE_PREVIEW_CALL_LETTER = "InterviewSchedule/PreviewCallLetter";
export const INTERVIEW_SCHEDULE_RELEASE_CALL_LETTERS = "InterviewSchedule/ReleaseCallLetters";
export const INTERVIEW_SCHEDULE_UNRELEASE_CALL_LETTERS = "InterviewSchedule/UnreleaseCallLetters";
export const INTERVIEW_SCHEDULE_GET_CALL_LETTER_FOR_CANDIDATE = "InterviewSchedule/GetCallLetterForCandidate";
export const INTERVIEW_SCHEDULE_RECORD_CALL_LETTER_DOWNLOAD = "InterviewSchedule/RecordCallLetterDownload";

// Phase C.2 (Enterprise Language Configuration Foundation) — Admin-controlled Portal Language Mode
// (English Only / English + Regional Language) foundation. Distinct from the existing
// ENTERPRISE_CONFIG_GET_LANGUAGE mechanism above (which backs the current candidate-facing language
// selector) — deliberately left untouched by this phase.
export const LANGUAGE_CONFIG_GET_PORTAL_LANGUAGE_CONFIG = "LanguageConfig/GetPortalLanguageConfig";
export const LANGUAGE_CONFIG_UPDATE_PORTAL_LANGUAGE_CONFIG = "LanguageConfig/UpdatePortalLanguageConfig";
export const LANGUAGE_CONFIG_GET_LANGUAGE_MASTER_LIST = "LanguageConfig/GetLanguageMasterList";
export const LANGUAGE_CONFIG_GET_SELECTABLE_REGIONAL_LANGUAGES = "LanguageConfig/GetSelectableRegionalLanguages";
export const LANGUAGE_CONFIG_UPDATE_LANGUAGE_ACTIVE = "LanguageConfig/UpdateLanguageActive";

// Phase R6.5 (Admin-Configurable Payment Gateway): mirrors the LANGUAGE_CONFIG_* pair above — a
// dedicated, Global-Admin-only read/write pair on the same generic EnterpriseConfiguration store
// (Category='PaymentGateway'), via its own small backend controller.
export const PAYMENT_GATEWAY_CONFIG_GET = "PaymentGatewayConfig/GetPaymentGatewayConfig";
export const PAYMENT_GATEWAY_CONFIG_UPDATE = "PaymentGatewayConfig/UpdatePaymentGatewayConfig";

// Sprint 2.7.1 (Enterprise Communication Foundation)
export const COMMUNICATION_GET_HEALTH = "Communication/GetHealth";
export const COMMUNICATION_TEST_EMAIL = "Communication/TestEmail";
export const COMMUNICATION_TEST_SMS = "Communication/TestSms";
// Sprint 2.7.2 (Enterprise Communication Engine)
export const COMMUNICATION_GET_QUEUE_SUMMARY = "Communication/GetQueueSummary";

// Sprint 2.3 (System Health, Diagnostics & Backup Awareness)
export const SYSTEM_HEALTH_GET_STATUS = "SystemHealth/GetHealthStatus";
export const SYSTEM_HEALTH_GET_DIAGNOSTICS = "SystemHealth/GetDiagnostics";
export const SYSTEM_HEALTH_GET_BACKUP_STATUS = "SystemHealth/GetBackupStatus";
export const SYSTEM_HEALTH_GET_RECENT_SECURITY_EVENTS = "SystemHealth/GetRecentSecurityEvents";

// Sprint 2.3 (Operational Dashboard / Compliance Dashboard APIs)
export const OPERATIONAL_DASHBOARD_GET_METRICS = "OperationalDashboard/GetMetrics";
export const COMPLIANCE_DASHBOARD_GET_METRICS = "ComplianceDashboard/GetMetrics";

//#endregion

//#region messages
export const GENERAL_ERROR_MESSAGE = 'Something went wrong';
export const PASSWORD_UPDATE_SUCCESS = 'Password updated successfully.';
export const SEND_EMAIL_SUCCESS = "Reset password email sent successfully";
//#endregion

//#payment gateway
export const GET_INITIATE_PAYMENT = 'Transaction/InitiatePaymentCCAvenue';
export const VERIFY_PAYMENT = 'RazorPayTransaction/VerifyPayment';
export const GET_PAYMINO_PAYMENT_STATUS = 'Transaction/CaptureTransaction';
export const GET_LAST_TRANSACTION = 'Transaction/GetLastTransaction';

//#Captcha
export const GET_CAPTCHA = 'Captcha/GetCaptcha';
export const GET_RESET_DATABASE = 'Captcha/ResetData';

// Post Configuration
export const GET_POST_CONFIGURATION_DATA = 'PostConfiguration/GetPostConfigurationData';
export const ADD_UPDATE_POST_CONFIGURATION = 'PostConfiguration/AddUpdatePostConfiguration';

// Export Photo Signature
export const EXPORT_ALL_IMAGES_DATA = 'Registration/ExportAllImagesData';

export const LOGIN_TIME = "LOGIN_TIME";


// Bank Admin
export const BANK_ADMIN_LOGIN = "Registration/BankAdminLogin";
export const GET_CANDIDATE_DETAILS = "Registration/GetStudentDataForBank";
export const UPDATE_CANDIDATE_TRANSACTION_DATA = "Registration/UpdateStudentBankTrasactionData";

// Help Desk Admin Login
export const HELP_DESK_ADMIN_LOGIN = "Registration/HelpDeskAdminLogin";
export const IMPORT_ONLINE_TRANSACTIONS_DATA = "OnlineTransactionData/ImportOnlineTransactionData";
export const GET_ALL_STUDENTS_DATA_FOR_HELP_DESK = "OnlineTransactionData/GetAllOnlineTransactionStudentsData";
export const GET_ALL_CANDIDATES_FROM_DB = "Registration/GetAllStudentsDatabaseData";
export const UPDATE_STUDENT_APPROVAL_REJECT_STATUS = "OnlineTransactionData/ApproveRejectStudentPaymentData";

// Biometric Admin Login
export const BIOMETRIC_ADMIN_LOGIN = "Registration/BiometricAdminLogin";
export const INITIALIZE_NSDL = "Biometric/InitializedNSDL";
export const GET_REPORT_BY_CLIENT_ID = "Biometric/GetReportByClinetId";
export const UPDATE_STUDENT_BIOMETRIC_DATA = "Biometric/UpdateStudentBiometricData";

//Aadhar Authentication

// export const GENERATE_AADHAAR_OTP = "https://sandbox.surepass.io/api/v1/aadhaar-v2/generate-otp";
// export const SUBMIT_AADHAAR_OTP = "https://sandbox.surepass.io/api/v1/aadhaar-v2/submit-otp";

export const GET_AADHAR_LOG_DATA_COUNT_BY_POST_AND_AADHAR_NUMBER = "Biometric/GetAadharLogDataCountByPostAndAadharNumber";
export const ADD_OR_UPDATE_STUDENT_AADHAR_LOG = 'Biometric/AddOrUpdateStudentAadharLog';

// Sprint 2.6.1 (Enterprise Identity Modernization): Mobile OTP + Email OTP, the active identity
// verification mechanism replacing Aadhaar above. This app's own backend routes (IdentityVerificationController),
// not vendor URLs, so declared as plain literals like most other endpoints in this file.
// Phase C.7.4D-R5.3: all 4 of these pointed at "Identity/..." — the controller's actual name (and thus
// its default Web API route) is "IdentityVerification", not "Identity". Confirmed live: every call
// through these constants 404'd ("No type was found that matches the controller named 'Identity'"),
// which is why Email/Mobile OTP always failed through the real UI even while direct calls to the
// correct URL (used for R5.2's own testing) succeeded — a genuine, pre-existing frontend/backend URL
// mismatch, not a SendGrid/SMTP issue at all.
export const GENERATE_MOBILE_OTP = "IdentityVerification/GenerateMobileOtp";
export const VERIFY_MOBILE_OTP = "IdentityVerification/VerifyMobileOtp";
export const GENERATE_EMAIL_OTP = "IdentityVerification/GenerateEmailOtp";
export const VERIFY_EMAIL_OTP = "IdentityVerification/VerifyEmailOtp";


export const JUNIOR_MANAGEMENT_ID = 1;
export const JUNIOR_CLERK_ID = 2;
export const PEON_ID = 3;


export const LAW_OFFICER_BANKING_OFFICER_GR2_ID = 1;
export const ASSISTANT_LAW_OFFICER_CLERK_ID = 2;
export const CA_BANKING_OFFICER_GR1_ID = 3;
export const IT_OFFICERS_BANKING_OFFICER_GR1_ID = 4;
export const IT_OFFICERS_BANKING_OFFICER_GR2_ID = 5;
export const STENOGRAPHER_CLERK_ID = 6;
export const ACCOUNTANT_BANKING_OFFICER_GR2_ID = 7;
export const CLERK_ID = 8;


export const ST_CATEGORY_ID = 2;
export const SC_CATEGORY_ID = 1;
export const OPEN_CATEGORY_ID1 = 9;
export const EWS_CATEGORY_ID1 = 11;

export const OPEN_CATEGORY_ID = "9";
export const OBC_CATEGORY_ID = "3";
export const EWS_CATEGORY_ID = "11"

export const Qualification_DEGREE_ID = 3;
export const Qualification_PG_ID = 4;
export const Qualification_Diploma_ID = 5;

export const BACKYEARS = 51;
export const BACK_YEARS_FOR_PASSING_YEAR = 80;
export const TRANSACTIONNUMBERCOUNT = 6;